import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

import { PivotFetchData } from '@types'

import { prepareResponseError } from '../utils/helpers'

import { useRepositoriesStore } from '../repositories/index'

import axios from 'axios'

import api from '@/store/api'

export const useLinkedDataTransactionsPivotStore = defineStore(
  'linked-data-transaction-pivot',
  () => {
    // INIT
    const repositoriesStore = useRepositoriesStore()

    // Bumped by `clear()` so every mounted pivot widget knows to refetch, since fetch state
    // (request lifecycle, result data) is owned per-widget, not here — see
    // `LinkedTransactionsPivot.vue`.
    const invalidatedAt = ref(0)

    const repositoryId = computed(() => repositoriesStore.getCurrentId)

    // ACTIONS

    // Stateless: resolves with the fetched rows, or `undefined` if the caller's own `signal`
    // aborted the request. Each widget owns its own request lifecycle (and result), so two
    // widgets fetching concurrently never cancel or overwrite each other's data.
    const fetch = async (
      data: PivotFetchData,
      signal?: AbortSignal,
    ): Promise<Record<string, any>[] | undefined> => {
      try {
        const result = await api.get('linked_data/transactions_pivot', {
          params: {
            repository_id: repositoryId.value,
            rows: JSON.stringify(data.rows),
            columns: JSON.stringify(data.cols),
            values: JSON.stringify(data.values),
            filter: JSON.stringify(data.filter),
          },
          signal,
        })
        return result.data
      } catch (e) {
        // Superseded by a newer request; ignore abort error.
        if (axios.isCancel(e)) return undefined
        throw Error(prepareResponseError(e))
      }
    }

    const clear = () => {
      invalidatedAt.value++
    }

    return {
      invalidatedAt,

      fetch,

      clear,
    }
  },
)
